import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import element1 from '../assets/images/star-symbol.svg';
import needImg from '../assets/images/need-img.png';
import { useWebContent } from '../hooks/useWebContent';

// Import SVG Icons
import { CallSVG, EmailSVG, StarElementSVG, SupportIconSVG } from '../components/SvgIcons';

const NeedSupportSection = () => {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  // Fetch web content using the hook
  const { data: webContent, isLoading, isError, error } = useWebContent();

  // Extract support-section data
  const supportSection = webContent?.dataset?.data?.['support-section']?.json_data;

  if (!supportSection) return null;

  // Default static values for fallback
  const defaultData = {
    title: 'Need support?',
    subtitle: 'MCQs, Notes, Tests & Lectures for All Competitive Exams',
    sectionImage: needImg,
    buttons: [
      { url: '#', text: 'Call us now', image: null, svg: 'call' },
      { url: '#', text: 'Email us now', image: null, svg: 'email' },
    ],
  };

  // Dynamic data from support-section
  const sectionData = {
    title: supportSection?.heading_text || defaultData.title,
    subtitle: supportSection?.title || defaultData.subtitle,
    sectionImage: supportSection?.section_image || defaultData.sectionImage,
    buttons: Array.isArray(supportSection?.buttons) && supportSection.buttons.length
      ? supportSection.buttons
      : defaultData.buttons,
  };

  const renderButtonIcon = (button, index) => {
    const text = String(button?.text || '').toLowerCase();
    const wantCall = button?.svg === 'call' || /call|phone/.test(text) || index === 0;
    const wantEmail = button?.svg === 'email' || /mail|email/.test(text) || index === 1;

    // 1) Explicit SVG (preferred)
    if (button?.svg === 'call') return <CallSVG />;
    if (button?.svg === 'email') return <EmailSVG />;

    // 2) Provided image
    if (button?.image) return <img src={button.image} alt="" className="btn-icon" />;

    // 3) Heuristic SVG by text
    if (wantCall) return <CallSVG />;
    if (wantEmail) return <EmailSVG />;

    // 4) Legacy Font Awesome fallback
    return (
      <i
        className={`fa fa-${wantCall ? 'phone' : 'envelope'}`}
        aria-hidden="true"
      ></i>
    );
  };

  const buttonClass = (button, index) => {
    const text = String(button?.text || '').toLowerCase();
    const isCall = button?.svg === 'call' || /call|phone/.test(text) || index === 0;
    return `btn get-btn2 ${isCall ? 'call-btnn' : 'email-btnn'}`;
  };

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error: {error?.message}</div>;

  return (
    <section className="support-section">
      <Container>
        <div className="needSupport-block">
          <div className="element">
            <span className="element1">
              {/* <img src={element1} alt="star symbol" /> */}
              <StarElementSVG />
            </span>
            <span className="element2">
              {/* <img src={element1} alt="star symbol" /> */}
              <StarElementSVG />
            </span>
          </div>

          <div
            className="section_title d-flex support-content justify-content-between align-items-center aos-init aos-animate"
            data-aos="fade-in"
            data-aos-duration="1500"
            data-aos-delay="100"
          >
            <div className="support-img">
              {/* <img src={sectionData.sectionImage} alt="support section" /> */}
              <SupportIconSVG />
            </div>

            <div className="support-text">
              <h3 className="text-white mb-0">{sectionData.title}</h3>
              <p className="text-white mb-0">{sectionData.subtitle}</p>
            </div>

            <div className="support-btns">
              {sectionData.buttons.map((button, index) => (
                <a
                  key={index}
                  href={button?.url || '#'}
                  className={buttonClass(button, index)}
                  data-aos="fade-in"
                  data-aos-duration="1500"
                >
                  {renderButtonIcon(button, index)}
                  {button?.text || (index === 0 ? 'Call us now' : 'Email us now')}
                </a>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default NeedSupportSection;



